module.exports = __webpack_public_path__ + "img/add-img.d20c7ee3.png";